import React,{ Component } from 'react';
import {
  Container,
  Row,
  Col,
  Nav,
  NavItem,
  NavLink
} from 'reactstrap';

import Link from 'react-router-dom/NavLink';
import Route from 'react-router-dom/Route';
import Switch from 'react-router-dom/Switch';

import HelpContactInfo from '../../HelpContactInfo';
import HelpFAQs from '../../HelpFAQs';
import HelpBestPractices from '../../HelpBestPractices';

class Help extends Component {
  render(){
    const {match} = this.props

    return (
      <Container className='Help'>
        <Row>
          <Col xs='12'>
            <br />
            <br />
            <h1>Help</h1>
            <p>
              Discover tips, access creative specs, find answers to common questions, or get help!
            </p>
          </Col>
        </Row>
        <Row>
          <Col xs='12'>
            <br />
            <Nav tabs className='UnderLineTabs'>
              <NavItem>
                <NavLink
                  tag={Link}
                  to={`${match.url}/faqs`}
                  activeClassName='active'
                >
                  FAQs
                </NavLink>
              </NavItem>
              <NavItem>
                <NavLink
                  tag={Link}
                  to={`${match.url}/best-practices`}
                  activeClassName='active'
                >
                  Best Practices
                </NavLink>
              </NavItem>
              <NavItem>
                <NavLink
                  tag={Link}
                  to={`${match.url}/contact`}
                  activeClassName='active'
                >
                  Contact Us
                </NavLink>
              </NavItem>
            </Nav>
            <br />
          </Col>
        </Row>
        <Switch>
          <Route
            exact path={`${match.url}/best-practices`}
            component={HelpBestPractices}
          />
          <Route
            exactly path={`${match.url}/faqs`}
            component={HelpFAQs}
          />
          <Route
            path={`${match.url}/contact`}
            component={HelpContactInfo}
          />
        </Switch>
      </Container>
    )
  }
}

export default Help;



// WEBPACK FOOTER //
// ./src/routes/Help/components/Help.js